import { useTranslation } from "react-i18next";

import { PageTable } from "@components/organisms/pageTable";
import { path } from "@routes/path.ts";
import type { IConferencePaperTableProps } from "@/template/articlesAndBooks/conferencePaper/table/types";
import { useConferencePaperListColumns } from "@/template/articlesAndBooks/conferencePaper/table/columns";

export function ConferencePaperTable(props: IConferencePaperTableProps) {
  const {
    data,
    isLoading,
    total,
    tableParamProps,
    isError,
    isFetching,
    noAction,
  } = props;
  const { t } = useTranslation(["subtitle", "common"]);
  const columns = useConferencePaperListColumns(props);

  return (
    <PageTable
      title={t("listOfPapersPublishedInConference")}
      placeholder={t("common:tablesSearch.publishedArticles")}
      type={"basic"}
      tableProps={{
        columnDef: columns,
        dataJSON: data,
        hasActionCell: true,
        showRow: true,
      }}
      total={total}
      isFetching={isFetching}
      isError={isError}
      isLoading={isLoading}
      action={
        noAction
          ? undefined
          : {
              label: "addPaper",
              to: path.conferencePapersPath.create(),
            }
      }
      {...tableParamProps}
    />
  );
}
